import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

const BadgeWrapper = styled.div`
	${({ theme }) => theme.fonts.primaryMedium};
	display: inline-block;
	background: ${({ theme, variant }) => theme.colors[variant]};
	border-radius: 3px;
	color: ${({ theme, variant }) => (variant === 'white' ? theme.colors.primary : theme.colors.white)};
	margin-right: 8px;
	padding: 0 8px;
	text-align: center;
	text-transform: capitalize;
`

Badge.propTypes = {
	context: string.isRequired,
	variant: string,
}

/**
 * Badge Component, small element to display labels
 * @param {String} props.context :: badge label
 * @param {String} props.variant :: determines how the badge displays based on set variations
 * ex: 'primary', 'secondary', 'tertiary'
 */
export function Badge({ context, variant = 'primary' }) {
	return <BadgeWrapper variant={variant}>{context}</BadgeWrapper>
}
